<template>
  <div style="padding-left:5px;padding-right:5px;">
    <EditSpecUpdateDialog
      :dialog="showEditSpecUpdateDialog"
      :version="specUpdate.version"
      :path="specUpdate.path"
      :prerequisites="specUpdate.prerequisites"
      :active="specUpdate.active"
      :targetFamily="specUpdate.targetFamily"
      :filter="specUpdate.filter"
      @close="closeEditSpecUpdateDialog"
    >
    </EditSpecUpdateDialog>

    <v-card flat>
      <v-data-table
        class="mt-5"
        single-select
        :footer-props="{ disableItemsPerPage: true, showFirstLastPage: true, showCurrentPage: true }"
        :headers="headers"
        :loading="busy"
        :items="specs"
        :items-per-page="10"
        :server-items-length="serverItemsLength"
        :options.sync="options"
      >
        <template v-slot:item.isFiltered="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <div v-on="on">{{ item.isFiltered }}</div>
            </template>
            <span>{{ item.filter.join(',') }}</span>
          </v-tooltip>
        </template>

        <template v-slot:item.action="{ item }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on }">
              <v-icon small class="mr-2" @click.stop="openEditSpecUpdateDialog(item)" v-on="on">edit</v-icon>
            </template>
            <span>Edit Spec</span>
          </v-tooltip>
        </template>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
import moment from 'moment';
import EditSpecUpdateDialog from './EditSpecUpdateDialog.vue';

export default {
  components: {
    EditSpecUpdateDialog,
  },

  data() {
    return {
      options: {},
      busy: false,
      serverItemsLength: 0,
      specs: [],

      specUpdate: {
        version: {
          name: '',
        },
        prerequisites: {},
      },
      showEditSpecUpdateDialog: false,

      headers: [
        {
          text: 'Display Name',
          align: 'left',
          sortable: false,
          value: 'version.name',
          width: 50,
        },
        {
          text: 'Month',
          align: 'right',
          sortable: false,
          value: 'version.month',
          width: 50,
        },
        {
          text: 'Year',
          align: 'right',
          sortable: false,
          value: 'version.year',
          width: 50,
        },
        {
          text: 'Aligners Require',
          align: 'left',
          sortable: false,
          value: 'prerequisites.require',
          width: 100,
        },
        {
          text: 'Tru-Points Require',
          align: 'left',
          sortable: false,
          value: 'prerequisites.gtpsRequire',
          width: 100,
        },
        {
          text: 'Oasis Require',
          align: 'left',
          sortable: false,
          value: 'prerequisites.oasisRequire',
          width: 100,
        },
        {
          text: 'Active',
          align: 'left',
          sortable: false,
          value: 'isActive',
          width: 50,
        },
        {
          text: 'Target Family',
          align: 'left',
          sortable: false,
          value: 'targetFamily',
          width: 50,
        },
        {
          text: 'Filtered',
          align: 'left',
          sortable: false,
          value: 'isFiltered',
          width: 50,
        },
        {
          text: 'Path',
          align: 'left',
          sortable: false,
          value: 'path',
          width: 150,
        },
        {
          text: 'Created At',
          align: 'left',
          sortable: false,
          value: 'createdAt',
          width: 150,
        },
        {
          text: 'Updated At',
          align: 'left',
          sortable: false,
          value: 'updatedAt',
          width: 150,
        },
        {
          text: 'Actions',
          align: 'left',
          sortable: false,
          value: 'action',
          width: 100,
        },
      ],
    };
  },

  watch: {
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },
  },

  mounted() {
    this.getData();
  },

  beforeUpdate() {
  },

  updated() {
  },

  methods: {
    getData() {
      const options = {
        method: 'GET',
        url: `/read/spec_updates/v1/?page=${this.options.page || 1}`,
      };

      this.busy = true;

      this.axios(options)
        .then((res) => {

          this.busy = false;
          this.serverItemsLength = res.data.totalDocs;
          this.specs = res.data.docs.map((cur) => {
            const { createdAt, updatedAt, ...rest } = cur;
            const created = moment(createdAt);
            const updated = moment(updatedAt);

            rest.prerequisites.gtpsRequire = rest.prerequisites.gtpsRequire || 'N/A';
            rest.prerequisites.oasisRequire = rest.prerequisites.oasisRequire || 'N/A';

            return Object.assign({}, {
              createdAt: created.local().format('YYYY-MM-DD HH:mm:ss'),
              updatedAt: updated.local().format('YYYY-MM-DD HH:mm:ss'),
              isActive: rest.active.toString(),
              isFiltered: (rest.filter.indexOf('*') === -1 && rest.filter.length >= 1).toString(),
            }, rest);
          });

          console.log(JSON.stringify(this.specs, null, 2));
        })
        .catch(() => {
          this.busy = false;
        });
    },

    openEditSpecUpdateDialog(specUpdate) {
      this.specUpdate = specUpdate;
      this.showEditSpecUpdateDialog = true;
    },

    closeEditSpecUpdateDialog(specUpdateUpdated) {
      this.showEditSpecUpdateDialog = false;
      this.specUpdate = {
        version: {
          name: '',
        },
        prerequisites: {},
      };

      if (specUpdateUpdated) {
        this.getData();
      }
    },
  },
};
</script>
